import { Component, type ErrorInfo, type ReactNode } from 'react'

type Props = { children: ReactNode }
type State = { error: Error | null }

/** Prevents a render crash from leaving mobile Safari on an empty white #root. */
export default class AppErrorBoundary extends Component<Props, State> {
  state: State = { error: null }

  static getDerivedStateFromError(error: Error): State {
    return { error }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('reDevicer render error', error, info.componentStack)
  }

  render() {
    if (!this.state.error) return this.props.children
    const dev = import.meta.env.DEV
    const err = this.state.error
    return (
      <div className="app-boot" role="alert" style={{ padding: 24, textAlign: 'center' }}>
        <p className="app-boot__brand" style={{ fontWeight: 800, fontSize: '1.5rem' }}>
          reDevicer
        </p>
        <p style={{ marginTop: 12, opacity: 0.9 }}>
          Nepavyko užkrauti puslapio. Patikrinkite ryšį ir bandykite dar kartą.
        </p>
        {dev && err ? (
          <pre
            style={{
              marginTop: 16,
              maxWidth: 'min(720px, 100%)',
              marginInline: 'auto',
              padding: 12,
              textAlign: 'left',
              overflow: 'auto',
              fontSize: 12,
              borderRadius: 10,
              background: '#fef2f2',
              color: '#b91c1c',
            }}
          >
            {err.name}: {err.message}
            {err.stack ? `\n\n${err.stack}` : ''}
          </pre>
        ) : null}
        <button
          type="button"
          style={{
            marginTop: 20,
            border: 0,
            borderRadius: 12,
            padding: '12px 18px',
            fontWeight: 700,
            background: '#38bdf8',
            color: '#0b1f3a',
          }}
          onClick={() => window.location.reload()}
        >
          Perkrauti
        </button>
      </div>
    )
  }
}
